// See https://stackoverflow.com/questions/5736398/how-to-calculate-the-svg-path-for-an-arc-of-a-circle 

const controlCssClass = 'js-radialGraph';
const circle = {
    radius: 100,
    x: 112,
    y: 112,
};

export default class RadialGraphs {
    constructor() {
        document.addEventListener('DOMContentLoaded', this._init.bind(this));
    }

    _init() {
        const controls = document.getElementsByClassName(controlCssClass);

        if (!controls || !controls.length) {
            return;
        }

        for (let i = 0; i < controls.length; i++) {
            const element = controls[i];

            const input = this._getInputValues(element);
            const degrees = this._convertToDegrees(input);

            if (degrees > 0) {
                const pathElement = element.querySelector('.radial-graph-arc_fg');
                if (pathElement) {
                    pathElement.setAttribute('d', this._describeArc(degrees));
                }
            }
        }
    }

    _convertToDegrees(input) {
        if (input.value <= 0) {
            return 0;
        }

        const progress = input.value / input.max;

        return 180 * progress;
    }

    // Maths... See https://www.mathsisfun.com/polar-cartesian-coordinates.html
    _convertPolarToCartesianCoordinates(centerX, centerY, radius, angleInDegrees) {
        const angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;

        return {
            x: centerX + (radius * Math.cos(angleInRadians)),
            y: centerY + (radius * Math.sin(angleInRadians)),
        };
    }

    /**
     * Dynamically creates an arc using an SVG <path> element. 
     * For more information see https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Paths#Arcs
     * 
     * @param {number} endAngle - The degree at which to stop drawing the arc. 
     *  For example `90` draws the arc one-quarter of a circle.
     * @returns {string} Representing the value of a (SVG) <path d> attribute.
     */
    _describeArc(endAngle) {
        const x = circle.x;
        const y = circle.y;
        const radius = circle.radius;
        const startAngle = 0;

        const start = this._convertPolarToCartesianCoordinates(x, y, radius, endAngle);
        const end = this._convertPolarToCartesianCoordinates(x, y, radius, startAngle);

        const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';

        const d = [
            'M', start.x, start.y,
            'A', radius, radius, 0, largeArcFlag, 0, end.x, end.y,
        ].join(' ');

        return d;
    }

    _getInputValues(element) {
        const value = element.dataset.graphValue.replace(/[^0-9]/g, '');
        const max = element.dataset.graphMax.replace(/[^0-9]/g, '');

        return {
            value: value ? parseInt(value, 10) : 0,
            max: max ? parseInt(max, 10) : 0,
        };
    }
}
